var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 12.2V10.6C21.8 9.71634 21.0836 9 20.2 9H10.6C9.71634 9 9 9.71634 9 10.6V23.3999C9 24.2836 9.71634 24.9999 10.6 24.9999H20.2C21.0836 24.9999 21.8 24.2836 21.8 23.3999V21.8",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7657 14.5027L24.2971 14.0341C23.9846 13.7217 23.4781 13.7217 23.1657 14.0341L17.7426 19.4572C17.5192 19.6806 17.367 19.9651 17.305 20.2748L17 21.7998L18.525 21.4948C18.8347 21.4328 19.1192 21.2806 19.3426 21.0572L24.7657 15.6341C25.0781 15.3217 25.0781 14.8152 24.7657 14.5027Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7998 15.4004L23.3998 17.0004",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4004 22.5996H12.2004L13.2004 20.5996L14.2004 22.5996H15.0004",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2002 12.2002H18.6002",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2002 15.4004H17.0002",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contract_icon.3c22e2ea1eec1ee058db849a1bb9dc4a.svg";
export { ForwardRef as ReactComponent };